// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'diamond';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.936 9.936c-.504-.504-.504-1.368 0-1.944L7.992.936c.504-.504 1.368-.504 1.944 0l7.056 7.056c.504.504.504 1.368 0 1.944l-7.056 7.056c-.504.504-1.368.504-1.944 0z'
  />
);

export const viewBox = '0 0 18 18';
